"use strict";
var onErrorResumeNext_1 = require('../operator/onErrorResumeNext');
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/observable/onErrorResumeNext.js
// module id = ../../../../rxjs/observable/onErrorResumeNext.js
// module chunks = 4